import { ZfStack, ZfTypography } from '@zafire/react';
import type { ICellRendererParams } from 'ag-grid-enterprise';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { ILiquidityCalculatorTableRow } from '../../interfaces';

export const LiquidityCalculatorPositionNameCell: FunctionComponent<ICellRendererParams<ILiquidityCalculatorTableRow, string>> = ({ data, value }) => {
    const { t } = useTranslation();

    if (data?.percentage == null)
        return (
            <ZfTypography variant="body-small" color="normal">
                {value ?? ''}
            </ZfTypography>
        );

    return (
        <ZfStack direction="column" style={{ lineHeight: 'var(--type-body-small-line-height)' }}>
            <ZfTypography variant="body-small" color="normal" weight="bold">
                {value}
            </ZfTypography>
            <ZfTypography variant="body-small" color="muted">
                {t('liquidityCalculatorTable.percentageSubtitle', { percentage: data.percentage })}
            </ZfTypography>
        </ZfStack>
    );
};
